interface AssetData {
    kind?: string;
    src?: string;
    '@data'?: HTMLImageElement | null;
    [key: string]: unknown;
}

interface EntityWithAsset {
    asset?: AssetData;
    [key: string]: unknown;
}

class Asset {
    static async loadAll(entities: EntityWithAsset[] | Record<string, unknown>): Promise<unknown> {
        const results: Promise<void>[] = [];
        for (const entity of Object.values(entities) as EntityWithAsset[]) {
            const asset = entity.asset;
            if (!asset) continue;

            if (asset['@data']) {
                return Promise.resolve(entity);
            }
            const updated = Asset.update(asset);
            if (updated) results.push(updated);
        }

        return Promise.all(results);
    }

    static updateAll(assets: AssetData[]): (Promise<void> | undefined)[] {
        const results: (Promise<void> | undefined)[] = [];
        assets.forEach((asset) => {
            results.push(Asset.update(asset));
        });
        return results;
    }

    static update(asset: AssetData): Promise<void> | undefined {
        asset['@data'] = null;
        if (asset.kind === 'image' && Asset.isValidImageSrc(asset.src)) {
            const image = new Image();
            const promise = new Promise<void>((resolve, reject) => {
                image.addEventListener(
                    'load',
                    () => {
                        asset['@data'] = image;
                        resolve();
                    },
                    { once: true },
                );
                image.addEventListener(
                    'error',
                    (ev) => {
                        // TODO: Better error handling
                        reject(ev);
                    },
                    { once: true },
                );

                image.src = asset.src!;
            });

            return promise;
        }
    }

    static isValidImageSrc(src: unknown): boolean {
        if (typeof src !== 'string') {
            return false;
        }

        const normalized = src.trim().toLowerCase();
        return normalized !== '' && normalized !== 'undefined' && normalized !== 'null';
    }
}

export { Asset as default };
